import Copy from '../../../components/copy';
import {useNavigate} from 'react-router-dom';
import {useDispatch} from 'react-redux';
import {confirmBitcoinCashoutRequest} from '../../../../reducers/app/actions';

export default ({cashout_request, button}) => {
    const addressFormat = address => {
        let string = ``;
        string += address.substr(0, 8);
        string += `...`;
        string += address.substr(-4);
    
        return string;
    }

    const dispatch = useDispatch(),
          navigate = useNavigate();

    const isOverload = (cashout_request.comission.usd / cashout_request.total_amount.usd) > 0.07;
 
    return (
        <>
            <div className="page-title">Bitcoin</div>
            <div className="page-descriptions">Review the information and confirm your withdrawal request</div>

            <div className="cashout-receipt">
                <div className="amount">-{cashout_request.total_amount.btc} BTC</div>
                <div className="amount_cur">~{cashout_request.total_amount.usd.toFixed(2)} USD</div>

                <div className="receipt-data">
                    <div className="receipt-data-line">
                        <div className="title">Network</div>
                        <div className="value">Bitcoin (BTC)</div>
                    </div>
                    <div className="receipt-data-line">
                        <div className="title">Address</div>
                        <div className="value" style={{flexDirection: 'row', gap: "10px", alignItems: 'center'}}>
                            {addressFormat(cashout_request.address)}
                            <Copy value={cashout_request.address} fill="#FFFFFF" size={24} />
                        </div>
                    </div>
                </div>
            </div>

            <div className="receipt-data">
                <div className="receipt-data-line bg">
                    <div className="title">Fee</div>
                    <div className="value" style={{
                        color: !isOverload ? `#ffffff` : '#ff7474'
                    }}>
                        {isOverload ? '⚠️ ' : ''}{cashout_request.comission.btc} BTC
                        <div className="descriptions">~{cashout_request.comission.usd.toFixed(2)} USD</div>
                    </div>
                </div>

                <div className="receipt-data-line bg">
                    <div className="title">Total amount</div>
                    <div className="value">
                        {cashout_request.amount.btc} BTC
                        <div className="descriptions">~{cashout_request.amount.usd.toFixed(2)} USD</div>
                    </div>
                </div>
            </div>

            <div className="button blue" style={{
                opacity: button ? 0.7 : 1,
                cursor: button ? 'no-drop' : 'pointer'
            }} onClick={e => {
                if(button)
                    return;

                dispatch(confirmBitcoinCashoutRequest(cashout_request.paymentId))
            }}>{isOverload ? `⛔️ Confirm ⛔️` : 'Confirm'}</div>

            <div className="button" onClick={e => {
                navigate('/cashout');
            }}>Cancel</div>
        </>
    )
}